import { FundPerformance } from 'src/app/domain/fund-performance/dto/FundPerformance';
import { ExcelTemplate } from '../../interfaces';
import { getFpHeaders } from './headers';
import * as XLSX from 'xlsx-js-style';
import { getPreparedData } from './mappings';
import { setColumnWidth, withHeaderStyling } from '../../utils';
import { fitToColumn } from '../financial-statement/utils';

export class FundPerformanceHighLevelTableTemplate implements ExcelTemplate {

  export(fundPerformances: FundPerformance[]): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(fundPerformances);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }


  private getSheet(fundPerformances: FundPerformance[]): XLSX.WorkSheet {
    const headers = getFpHeaders();
    const preparedData = getPreparedData(fundPerformances, headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    const whiteSpaceIndexses = [2, 8, 13, 19, 22, 27, 36];
    whiteSpaceIndexses.forEach((index) => setColumnWidth(sheet, index, 1.5));
    return withHeaderStyling(sheet);
  }
}
